import moment from 'moment';
import { z } from 'zod';

// Define inline type to avoid circular reference with TOnsiteInterviewFormData
const ruleDepartureTimeMustBeAfterArrivalTime = ({
  hoursArrival,
  hoursDeparture,
}: {
  hoursArrival: string;
  hoursDeparture: string;
}): boolean => {
  const arrival = moment(hoursArrival, 'h:mm A');
  const departure = moment(hoursDeparture, 'h:mm A');

  return departure.isAfter(arrival);
};

export const OnsiteInterviewFormRules = z
  .object({
    dates: z.array(z.date()).min(1),
    profession: z.string().min(1),
    specialty: z.string().min(1),
    isAssistedHygiene: z.boolean().default(false),
    hoursArrival: z.string().regex(/^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(am|pm)$/i),
    hoursDeparture: z.string().regex(/^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(am|pm)$/i),
    breakTime: z
      .enum(['0 min', '15 min', '30 min', '45 min', '1 hr', '1.5 hr', '2 hr'])
      .nullable()
      .default(null),
    isPaidBreakTime: z.boolean().default(false),
    hourlyRate: z.string().regex(/^\d+(\.\d{2})$/),
    professionals: z.array(z.object({ label: z.string(), value: z.string() })).optional(),
  })
  .refine(ruleDepartureTimeMustBeAfterArrivalTime, {
    message: 'departure time must be after arrival time',
    path: ['hoursDeparture'],
  });

export type TOnsiteInterviewFormData = z.infer<typeof OnsiteInterviewFormRules>;

export type TBreakTime = NonNullable<TOnsiteInterviewFormData['breakTime']>;
